import { cn } from '../lib/utils';

export const ProgressBar = ({ currentStep, totalSteps }) => {
  const progress = (currentStep / totalSteps) * 100;
  
  return (
    <div 
      className="w-full h-2 bg-[#F3F0F8] overflow-hidden"
      role="progressbar"
      aria-valuenow={currentStep}
      aria-valuemin={0}
      aria-valuemax={totalSteps}
      aria-label={`Step ${currentStep} of ${totalSteps}`}
    >
      <div
        className={cn(
          'h-full bg-gradient-to-r from-[#5a2f92] to-[#7b4fb5] bonza-progress-bar'
        )}
        style={{ width: `${progress}%` }}
      />
    </div>
  );
};

export const StepIndicator = ({ currentStep, totalSteps }) => {
  return (
    <div className="flex items-center gap-2 text-sm text-[#64748B]">
      <span className="font-medium text-[#5a2f92]">Step {currentStep}</span>
      <span>of</span>
      <span>{totalSteps}</span>
    </div>
  );
};
